import { useState, useEffect } from "react";

export const FlowerIcon = ({ size = 80, color = "#FF9ECD" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <ellipse cx="50" cy="22" rx="12" ry="20" fill={color} />
    <ellipse cx="50" cy="78" rx="12" ry="20" fill={color} />
    <ellipse cx="22" cy="50" rx="20" ry="12" fill={color} />
    <ellipse cx="78" cy="50" rx="20" ry="12" fill={color} />
    <ellipse cx="30" cy="30" rx="12" ry="20" transform="rotate(45 30 30)" fill={color} />
    <ellipse cx="70" cy="30" rx="12" ry="20" transform="rotate(-45 70 30)" fill={color} />
    <ellipse cx="30" cy="70" rx="12" ry="20" transform="rotate(-45 30 70)" fill={color} />
    <ellipse cx="70" cy="70" rx="12" ry="20" transform="rotate(45 70 70)" fill={color} />
    <circle cx="50" cy="50" r="16" fill="#FFE566" />
    <circle cx="50" cy="50" r="8" fill="#F5C800" />
  </svg>
);

export  const StarfishIcon = ({ size = 80, color = "#FF6B4A" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <path d="M50 5 L57 35 L88 28 L67 50 L88 72 L57 65 L50 95 L43 65 L12 72 L33 50 L12 28 L43 35 Z" fill={color} />
    <circle cx="50" cy="50" r="9" fill="#FF9E87" />
    {[0,1,2,3,4].map((_, i) => {
      const angle = (i * 72 - 90) * Math.PI / 180;
      return <circle key={i} cx={50 + Math.cos(angle)*22} cy={50 + Math.sin(angle)*22} r="3" fill="#FF9E87" opacity="0.7" />;
    })}
  </svg>
);

export const GoldfishIcon = ({ size = 80, color = "#FFB020" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <ellipse cx="48" cy="52" rx="26" ry="18" fill={color} />
    <path d="M22 52 C10 38 4 28 8 20 C14 34 22 42 22 52Z" fill="#FF8C00" />
    <path d="M22 52 C10 66 4 76 8 84 C14 70 22 62 22 52Z" fill="#FF8C00" />
    <path d="M62 38 Q78 30 80 52 Q78 74 62 66 Q72 52 62 38Z" fill="#FFD060" opacity="0.7" />
    <circle cx="70" cy="48" r="4" fill="white" />
    <circle cx="71" cy="48" r="2" fill="#222" />
    <circle cx="72" cy="47" r="0.8" fill="white" />
  </svg>
);

export const FlaskIcon = ({ size = 80, color = "#7EC8E3" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <rect x="40" y="10" width="20" height="6" rx="3" fill="#B0B0C8" />
    <rect x="43" y="14" width="14" height="22" rx="2" fill={color} opacity="0.6" />
    <path d="M43 36 L28 72 Q25 80 32 84 L68 84 Q75 80 72 72 L57 36 Z" fill={color} />
    <path d="M43 36 L28 72 Q25 80 32 84 L68 84 Q75 80 72 72 L57 36 Z" fill="white" opacity="0.2" />
    <ellipse cx="50" cy="70" rx="15" ry="8" fill="#A8E6FF" opacity="0.6" />
    <circle cx="40" cy="66" r="4" fill="#60D0FF" opacity="0.8" />
    <circle cx="56" cy="74" r="3" fill="#60D0FF" opacity="0.8" />
    <rect x="38" y="14" width="24" height="4" rx="2" fill="#9090A8" />
  </svg>
);

export const AlphaAIcon = ({ size = 80, color = "#A78BFA" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <path d="M50 12 L78 85 L65 85 L58 65 L42 65 L35 85 L22 85 Z" fill={color} />
    <path d="M46 52 L50 30 L54 52 Z" fill="white" opacity="0.9" />
    <rect x="39" y="52" width="22" height="6" rx="3" fill="white" opacity="0.9" />
    <circle cx="50" cy="12" r="5" fill={color} />
  </svg>
);

export const PlusIcon = ({ size = 60, color = "#4ADE80" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <rect x="38" y="8" width="24" height="84" rx="12" fill={color} />
    <rect x="8" y="38" width="84" height="24" rx="12" fill={color} />
  </svg>
);

export const SCATTER_PATTERN = [
  { C: FlowerIcon,    props: { color: "#FF9ECD" },       top: 6,  left: 5,  rot: 15,  size: 90,  op: 1,    delay: 0    },
  { C: StarfishIcon,  props: { color: "#FF6B4A" },       top: 3,  left: 72, rot: -10, size: 72,  op: 0.9,  delay: 0.1  },
  { C: GoldfishIcon,  props: { color: "#FFB020" },       top: 14, left: 85, rot: 8,   size: 80,  op: 1,    delay: 0.15 },
  { C: FlaskIcon,     props: { color: "#7EC8E3" },       top: 60, left: 2,  rot: -18, size: 78,  op: 1,    delay: 0.2  },
  { C: AlphaAIcon,   props: { color: "#A78BFA" },       top: 70, left: 80, rot: 12,  size: 84,  op: 1,    delay: 0.05 },
  { C: PlusIcon,      props: { color: "#4ADE80" },       top: 38, left: 90, rot: 0,   size: 52,  op: 0.85, delay: 0.25 },
  { C: FlowerIcon,    props: { color: "#FBBF24" },       top: 78, left: 60, rot: 30,  size: 64,  op: 0.8,  delay: 0.3  },
  { C: StarfishIcon,  props: { color: "#F97316" },       top: 82, left: 18, rot: -25, size: 56,  op: 0.75, delay: 0.18 },
  { C: PlusIcon,      props: { color: "#FB7185" },       top: 22, left: 2,  rot: 20,  size: 44,  op: 0.7,  delay: 0.35 },
  { C: GoldfishIcon,  props: { color: "#F472B6" },       top: 52, left: 76, rot: -12, size: 60,  op: 0.85, delay: 0.12 },
  { C: FlaskIcon,     props: { color: "#34D399" },       top: 5,  left: 42, rot: 5,   size: 54,  op: 0.7,  delay: 0.4  },
  { C: AlphaAIcon,   props: { color: "#60A5FA" },       top: 86, left: 88, rot: -8,  size: 58,  op: 0.8,  delay: 0.22 },
  { C: FlowerIcon,    props: { color: "#C084FC" },       top: 44, left: -2, rot: -20, size: 50,  op: 0.65, delay: 0.45 },
  { C: PlusIcon,      props: { color: "#38BDF8" },       top: 90, left: 42, rot: 45,  size: 40,  op: 0.6,  delay: 0.5  },
];


// ── Icons ─────────────────────────────────────────────────────────────────────

export const RocketIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"
      stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"
      stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
      stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CameraIcon = ({ size = 28, color = "#999" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="13" r="4" stroke={color} strokeWidth="1.8" />
  </svg>
);

export const CameraOffIcon = ({ size = 28, color = "#f87171" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M21 21H3a2 2 0 01-2-2V8a2 2 0 012-2h3m3-3h6l2 3h4a2 2 0 012 2v9.34"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.47 15.47A4 4 0 018.53 8.53" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const UserIcon = ({ color = "#bbb" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2" />
  </svg>
);

export const HashIcon = ({ color = "#bbb" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <line x1="4" y1="9" x2="20" y2="9" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="4" y1="15" x2="20" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="10" y1="3" x2="8" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="16" y1="3" x2="14" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const BookOpenIcon = ({ color = "#bbb" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);



// ─── Instruction card icon components ─────────────────────────────────────────



const StarIcon = ({ size = 28, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill={color} />
    </svg>
);

const BookIcon = ({ size = 28, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ClockIcon = ({ size = 28, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
        <path d="M12 6v6l4 2" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);



const NoPeekIcon = ({ size = 22, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);


export const CUSTOM_INSTRUCTIONS = [
    {
        Icon: BookIcon,
        iconBg: "#F59E0B",
        title: "Read Carefully",
        description: "Take your time to read every word of the question before you decide.",
    },
    {
        Icon: NoPeekIcon,
        iconBg: "#F97316",   // orange
        title: "No Peeking!",
        description: "The best way to learn is using your own brilliant brain. No cheating allowed!",
    },
    {
        Icon: ClockIcon,
        iconBg: "#3B82F6",
        title: "Watch the Clock",
        description: "Some challenges have a timer. Stay focused and keep your eyes on the prize!",
    },

];


// ── useIsMobile ───────────────────────────────────────────────────────────────
export function useIsMobile(bp = 600) {
    const [v, setV] = useState(() => typeof window !== "undefined" ? window.innerWidth < bp : false);
    useEffect(() => {
        const h = () => setV(window.innerWidth < bp);
        window.addEventListener("resize", h);
        return () => window.removeEventListener("resize", h);
    }, [bp]);
    return v;
}
